import { cn } from "@/lib/class-control";

export function StatusBadge({ status }: { status: string }) {
  const getStatusConfig = () => {
    switch (status) {
      case "ACTIVE":
      case "Em Execução":
        return { bg: "bg-[#F7DC4D]", text: "text-[#0C1427]", label: "Em Execução" };
      case "EXPIRED":
      case "Vencendo":
        return { bg: "bg-[#DC4426]", text: "text-white", label: "Vencendo" };
      case "PENDING":
      case "Solicitado":
        return { bg: "bg-[#7846FF]", text: "text-white", label: "Solicitado" };
      case "SIGNED":
      case "Concluído":
        return { bg: "bg-[#13D480]", text: "text-white", label: "Concluído" };
      default:
        return { bg: "bg-gray-500/20", text: "text-gray-400", label: status };
    }
  };

  const config = getStatusConfig();

  return (
    <span
      className={cn("px-[10px] py-[10px] rounded-[30px] text-xs font-bold",
        "inline-flex items-center justify-center", config.bg, config.text)}
    >
      {config.label}
    </span>
  );
}